import SearchProcessorContainer from './SearchProcessorContainer';

export default SearchProcessorContainer;
